import { Component, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent implements OnChanges {
  @Input() activeIndex: any;
  /** Si es requerido o no */
  @Input() required: boolean;
  /** Si es requerido o no la segunda sección */
  @Input() requiredSecond: boolean;
  /** Título del card */
  @Input() title: string;
  /** Subítulo del card */
  @Input() subtitle: string;
  /** Icono */
  @Input() iconTitle: string;
  /** Color icono */
  @Input() iconColor: string;
  /** Contenido del card */
  @Input() contentTemplate: TemplateRef<any>;
  /** Se pliega y despliega la tarjeta */
  @Input() hasDropdown: boolean = false;
  /** Si tiene una segunda sección */
  @Input() hasSecondSection: boolean = false;
  /** Segundo título */
  @Input() titleSecond: string;
  /** Segundo subtítulo */
  @Input() subtitleSecond: string;
  /** Segundo icono */
  @Input() iconTitleSecond: string;
   /** Segundo color icono */
  @Input() iconColorSecond: string;
   /** Segundo contenido del card */
  @Input() contentTemplateSecond: TemplateRef<any>;
  /** Boolean para hacer override en ngOnChanges y no cambiar el activeIndex */
  @Input() overrideCardDropdownStatus: boolean = false;

  constructor() {
    if(!this.activeIndex || this.activeIndex !== null) {
      this.activeIndex = 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.subtitle) {
      const previousSubtitle = changes.subtitle.previousValue as string;
      const currentSubtitle = changes.subtitle.currentValue as string;
      const previousSegment = previousSubtitle?.split('/')[1];
      const currentSegment = currentSubtitle?.split('/')[1];
      if (previousSegment !== currentSegment && !this.overrideCardDropdownStatus) {
        this.activeIndex = 1;
      }
    } 
  }

  open() {
    this.activeIndex = 0;
  }
}
